// regex playground: https://regex101.com/r/BTTm6b/2
const FIND_NUM_REG_EXP = /-?(\d+)(?:$|%|&|\D+$)/;
export const getEntityIdFromRouteParam = (
  rawParams?: string | null,
): number | null => {
  const matches = (rawParams ?? '').match(FIND_NUM_REG_EXP) || [];
  const entityId = matches[1] ? parseInt(matches[1], 10) : NaN;

  return isNaN(entityId) ? null : entityId;
};

// regex playground: https://regex101.com/r/HGz6jo/2
const FIND_SLUG_REG_EXP = /(.+)-(:?\d+)(?:$|%|&|\D+$)/;
export const getSlugFromRouteParam = (
  rawParams?: string | null,
): string | null => {
  const matches = (rawParams ?? '').match(FIND_SLUG_REG_EXP) || [];
  const slug = matches[1] as string | undefined;

  return slug || null;
};
